function remDiv(delNum) {
    var divid = 'plusitem' + delNum;
    document.getElementById(divid).remove();
  }
  
  function remAlert(id) {
    var x = document.getElementById(id);
    x.style.display = 'none';
  }
  
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  
  function ValidateName(inputText) {
    if (inputText) {
      //console.log("Name is true.");
      return true;
    } else {
      //console.log("Name is empty!");
      $('#validate-name').show();
  
      $('#ok-email').click(function () {
        $('#validate-name').css('display', 'none');
      });
  
      $('#name').css('border-color', 'red');
      $('#name').focus();
      return false;
    }
  }
  
  function nameClose() {
    $('#validate-name').css('display', 'none');
  }
  
  function emailClose() {
    $('#validate-email').css('display', 'none');
  }
  
  function ValidateEmail(inputText) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (inputText.match(mailformat)) {
      //console.log("Valid email address!");
      return true;
    } else {
      //console.log("You have entered an empty/invalid email address!");
      $('#validate-email').show();
  
      $('#ok-email').click(function () {
        $('#validate-email').css('display', 'none');
      });
  
      $('#email').css('border-color', 'red');
      $('#email').focus();
      return false;
    }
  }
  
  // For keyup
  function ValidateEmail2(inputText) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (inputText.match(mailformat)) {
      //console.log("Valid email address!");
      return true;
    } else {
      //console.log("You have entered an empty/invalid email address!");
      $('#email').css('border-color', 'red');
      $('#email').focus();
      return false;
    }
  }
  
  function checkTax() {
    var hcountry = $('#shipCountry').val();
    if (
      hcountry == 'France' ||
      hcountry == 'Ireland' ||
      hcountry == 'Greece' ||
      hcountry == 'Philippines' ||
      hcountry == 'Canada' ||
      hcountry == 'Brazil' ||
      hcountry == 'Tunisia' ||
      hcountry == 'Peru' ||
      hcountry == 'Mexico' ||
      hcountry == 'United Kingdom'
    ) {
      $('#testBtn').attr('disabled', true);
      $('#testBtn').css('background', '#dddddd');
      $('#testBtn').css('cursor', 'default');
    }
  }
  
  function inputLink(linkID) {
    linkID.css('border-color', 'red');
    linkID.focus();
  
    linkID.keyup(function () {
      var thelink = linkID.val();
      if (thelink === '') {
        linkID.css('border-color', 'red');
      } else {
        linkID.css('border-color', '#e5e4e2');
        return true;
      }
    });
  }
  
  function checkLink() {
    for (index = 0; index < arrProd.length; ++index) {
      var numField = arrProd[index];
      var linkField = 'contact[link' + numField + ']';
      var titleField = 'contact[title' + numField + ']';
      var linkID = $('[name="' + linkField + '"]');
      var title = $('[name="' + titleField + '"]');
      var linkVal = linkID.val();
      var titleVal = title.val();
      if (linkVal === '' && titleVal != '') {
        var ans = inputLink(linkID);
        if (ans) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  
  var customProductArray = [];
  var customPriceArray = [];
  var customNameArray = [];
  var customImageArray = [];
  
  console.log(document.cookie);
  var customProducts = getCookie('customProducts');
  var customPrices = getCookie('customPrices');
  var customNames = getCookie('customNames');
  var customImages = getCookie('customImages');
  
  if (customProducts != null) {
    customProductArray = customProducts.split(',');
  }
  
  if (customPrices != null) {
    customPriceArray = customPrices.split(',');
  }
  
  if (customNames != null) {
    customNameArray = customNames.split(',');
  }
  
  if (customImages != null) {
    customImageArray = customImages.split(',');
  }
  
  var exchPrice = 1230;
  
  $.get(
    'https://searchkorea.harum.io/api/harum/rate',
    function (data, status) {  
      exchPrice = data.rate;
    
      document.getElementById('currency-1').innerHTML = exchPrice + 'KRW';
      document.getElementById('currency-2').innerHTML = exchPrice + 'KRW';
    },
  );
  
  $(document).ready(function () {
    $('#name').keyup(function () {
      const name = $('#name').val();
      if (!name) {
        $('#name').css('border-color', 'red');
      } else {
        $('#name').css('border-color', '#e5e4e2');
      }
    });
  
    $('#email').keyup(function () {
      const emailadd = $('#email').val();
      var answer = ValidateEmail2(emailadd);
      if (!answer) {
        $('#email').css('border-color', 'red');
      } else {
        $('#email').css('border-color', '#e5e4e2');
      }
    });
  
    function printElement(elem) {
      var domClone = elem.cloneNode(true);
      var $printSection = document.getElementById('printSection');
      if (!$printSection) {
        var $printSection = document.createElement('div');
        $printSection.id = 'printSection';
        document.body.appendChild($printSection);
      }
  
      $printSection.innerHTML = '';
      $printSection.appendChild(domClone);
      window.print();
    }
  
    $('#draftInv').click(function () {
      var linkok = checkLink();
      if (linkok == null) {
        linkok = true;
      }
  
      const name = $('#name').val();
      const emailadd = $('#email').val();
      var hcountry = $('#shipCountry').val();
      var emailRes = true;
      var nameRes = true;
  
      if (name == '' && emailadd == '') {
        //console.log("name & email empty");
        $('#validate-ne').show();
        $('#ok-ne').click(function () {
          $('#validate-ne').css('display', 'none');
        });
  
        $('#name').css('border-color', 'red');
        $('#email').css('border-color', 'red');
        $('#name').focus();
        emailRes = ValidateEmail2(emailadd);
      }
  
      if (name == '' && emailadd != '') {
        nameRes = ValidateName(name);
      }
  
      if (name != '' && emailadd == '') {
        emailRes = ValidateEmail(emailadd);
      }
  
      if (!emailRes | !nameRes | !linkok) {
        // invalid email
      } else {
        var estTotalPrice = 0;
        var lineInv =
          "<table width='100%' border='0' cellpadding='2' cellspacing='1'><tr style='background:rgba(var(--kik-form-input-bg-color), 1)'><th>Link</th><th></th><th>Comments</th><th style='padding-left:5px;'>Quantity</th><th>Price (USD$)</th></tr>";
        var bunjangFees = 0;
        var lineNum = 1;
        var lineColor;
        var toRemDiv = new Array();
  
        for (index = 0; index < arrProd.length; ++index) {
          var numField = arrProd[index];
          var linkField = 'contact[link' + numField + ']';
          var titleField = 'contact[title' + numField + ']';
          var linkVal = $('[name="' + linkField + '"]').val();
          var titleVal = $('[name="' + titleField + '"]').val();
  
          if (linkVal === '' && titleVal === '') {
            remDiv(numField);
            toRemDiv.push(numField);
          } else {
            if (lineNum % 2 == 0) {
              lineColor = '#f8efeb';
            } else {
              lineColor = '#ffffff';
            }
  
            lineInv = lineInv + "<tr style='background:" + lineColor + "'>";
            var numField = arrProd[index];
            var nameField = 'contact[price' + numField + ']';
            var wonPrice = $('[name="' + nameField + '"]').val();
            wonPrice = wonPrice.replace(/[^0-9]/, '');
  
            var nameField = 'contact[qty' + numField + ']';
            var qtyNow = $('[name="' + nameField + '"]').val();
  
            var nameField = 'contact[comment' + numField + ']';
            var commentsVal = $('[name="' + nameField + '"]').val();
  
            if (Math.floor(qtyNow) == qtyNow && $.isNumeric(qtyNow)) {
              //do nothing for now
            } else {
              $('[name="' + nameField + '"]').val('1');
              qtyNow = 1;
            }
  
            wonPrice = wonPrice * qtyNow;
            if (wonPrice < exchPrice) {
              var estPrice = 1;
            } else {
              var estPrice = Math.round((wonPrice / exchPrice) * 100) / 100;
            }
  
            estTotalPrice = estTotalPrice + estPrice;
  
            var bunjangField = 'ContactFormBunjang' + numField;
            if ($('#' + bunjangField).is(':checked')) {
              bunjangFees = bunjangFees + 5;
            }
  
            var linkField = 'contact[link' + numField + ']';
            var linkVal = $('[name="' + linkField + '"]').val();
  
            lineInv = lineInv + "<td colspan='2'>" + linkVal + '</td>';
            lineInv = lineInv + '<td>' + commentsVal + '</td>';
            lineInv = lineInv + "<td class='mobQty'>" + qtyNow + '</td>';
            lineInv = lineInv + '<td>' + estPrice + '</td>';
            lineInv = lineInv + '</tr>';
  
            lineNum = lineNum + 1;
          }
        }
  
        //remove empty divs
        for (index = 0; index < toRemDiv.length; ++index) {
          var delNum = toRemDiv[index];
          for (jindex = 0; jindex < arrProd.length; ++jindex) {
            if (arrProd[jindex] == delNum) {
              arrProd.splice(jindex, 1);
              jindex = arrProd.length;
            }
          }
        }
  
        estTotalPrice = estTotalPrice + bunjangFees;
  
        var getShipMethod = $('#shipMethods').val();
        var getWeight = Math.ceil($('#estimatedWeight').val() * 2) / 2;
        var overweight = 0;
        var weightPrice = 0;
  
        if (getWeight < 1) {
          getWeight = 1;
        }
  
        var moreone = getWeight - 1;
  
        if (moreone > 0) {
          overweight = moreone * 10;
        }
  
        if (getShipMethod == 'airparcel' && getWeight > 2) {
          getShipMethod = 'dhl';
        }
  
        switch (getShipMethod) {
          case 'dhl':
          case 'fedex':
          case 'dhl/fedex':
            weightPrice = overweight + 34;
            break;
          case 'airparcel':
          case 'skynet':
          case 'cj':
          case 'ninjavan':
          case 'usps':
          case 'chunghwa':
          case 'sagawa':
            weightPrice = overweight + 20;
            break;
          default:
            weightPrice = overweight + 34;
        }
  
        if (estTotalPrice > 0) {
          estTotalPrice = estTotalPrice + weightPrice;
          estTotalPrice = estTotalPrice + 5;
          estTotalPrice = estTotalPrice.toFixed(2);
          $('#totalEstimate').val('USD$' + estTotalPrice + ' (Estimation only)');
          $('#totalEstimateShown').val(
            'USD$' + estTotalPrice + ' (Estimation only)',
          );
        }
  
        lineInv = lineInv + '</table><br><br>';
        lineInv = lineInv + "<hr style='width:80%'><br>";
        lineInv = lineInv + "<div style='padding-left:20px;'>";
        lineInv = lineInv + 'Service Fee: USD$5.00 <br>';
        lineInv = lineInv + 'Bunjang Fees: USD$' + bunjangFees + '.00 <br>';
        lineInv = lineInv + 'Estimated Weight: ' + getWeight + 'KG <br>';
        var getShipMethod = getShipMethod.toUpperCase();
        lineInv = lineInv + 'Shipping With: ' + getShipMethod + '<br>';
        lineInv =
          lineInv + 'Estimated Shipping Fees: USD$' + weightPrice + '.00<br>';
        lineInv =
          lineInv +
          '<br><b>Estimated Total: USD$' +
          estTotalPrice +
          '</b><br><br>';
  
        lineInv =
          lineInv + "<div id='taxDiv' style='margin-bottom: 20px;'></div>";
        lineInv = lineInv + "<div style='margin-bottom: 20px;'></div>";
        lineInv = lineInv + '</div>';
  
        if (isNaN($('#estimatedWeight').val())) {
          var z = document.getElementById('estimatedWeight');
          z.style.border = '2px solid red';
          var x = document.getElementById('weight-error');
          x.style.display = 'block';
        } else {
          var z = document.getElementById('estimatedWeight');
          z.style.border = 'none';
          document.getElementById('invContent').innerHTML = lineInv;
          var x = document.getElementById('prompt-background');
          x.style.display = 'block';
        }
  
        if (
          hcountry == 'France' ||
          hcountry == 'Ireland' ||
          hcountry == 'Greece' ||
          hcountry == 'Philippines' ||
          hcountry == 'Canada' ||
          hcountry == 'Brazil' ||
          hcountry == 'Tunisia' ||
          hcountry == 'Peru' ||
          hcountry == 'Mexico' ||
          hcountry == 'United Kingdom'
        ) {
          $('#taxDiv').append('<br>');
          $('#taxDiv').append(
            '<p class="cart-attribute__field">We noticed that your country is in ' +
              hcountry +
              '.<br>Form can only be submitted upon agreement to this clause. Thank you.',
          );
          $('#taxDiv').append(
            '<label style="font-size: 14px; font-weight: 600;">I agree to pay Customs Tax (if applicable)<br><i>* Payable to courier after package reaches destination country. <br>* Kindly note that we are unable to offer any refund if package is refused once shipped. <br>* If you have issues using this form, please contact us at support@harum.io </i></label><br>',
          );
          $('#taxDiv').append(
            '<select style="max-width: 100%; width: 200px;" required class="required" id="agree-to-pay" name="attributes[Tax Agree]"><option disabled selected value>Please Choose</option><option value="Yes"{% if cart.attributes["Agree to Pay"] == "Yes" %}selected{% endif %}>Yes</option><option value="No"{% if cart.attributes["Agree to Pay"] == "No" %}selected{% endif %}>No</option>',
          );
          $('#taxDiv').append('</select>');
          $('#taxDiv').append('</p>');
          $('#taxDiv').append('<br>');
        }
  
        $('#agree-to-pay').on('change', function () {
          var taxvalue = $('#agree-to-pay').val();
          if (taxvalue == 'Yes') {
            $('#testBtn').attr('disabled', false);
            $('#testBtn').css('background', '#c77e7a');
            $('#testBtn').css('cursor', 'pointer');
          } else {
            $('#testBtn').attr('disabled', true);
            $('#testBtn').css('background', '#dddddd');
            $('#testBtn').css('cursor', 'default');
          }
        });
      }
    });
  
    $('#shipCountry').on('change', function () {
      var shipVal = $('#shipCountry').val();
      switch (shipVal) {
        case 'Malaysia':
          $('.ship-method-select option[value="dhl/fedex"]').attr(
            'selected',
            false,
          );
          $('.ship-method-select option[value="cj"]').attr('selected', false);
          $('.ship-method-select option[value="airparcel"]').hide();
          $('.ship-method-select option[value="cj"]').hide();
          $('.ship-method-select option[value="ninjavan"]').hide();
          $('.ship-method-select option[value="chunghwa"]').hide();
          $('.ship-method-select option[value="sagawa"]').hide();
          $('.ship-method-select option[value="usps"]').hide();
          $('.ship-method-select option[value="skynet"]').show();
          $('.ship-method-select option[value="dhl/fedex"]').hide();
          $('.ship-method-select option[value="skynet"]').attr(
            'selected',
            'selected',
          );
          break;
        case 'Singapore':
          $('.ship-method-select option[value="dhl/fedex"]').attr(
            'selected',
            false,
          );
          $('.ship-method-select option[value="skynet"]').attr('selected', false);
          $('.ship-method-select option[value="airparcel"]').hide();
          $('.ship-method-select option[value="cj"]').show();
          $('.ship-method-select option[value="ninjavan"]').hide();
          $('.ship-method-select option[value="chunghwa"]').hide();
          $('.ship-method-select option[value="sagawa"]').hide();
          $('.ship-method-select option[value="usps"]').hide();
          $('.ship-method-select option[value="skynet"]').hide();
          $('.ship-method-select option[value="dhl/fedex"]').hide();
          $('.ship-method-select option[value="cj"]').attr(
            'selected',
            'selected',
          );
          break;
        case 'Philippines':
          $('.ship-method-select option[value="dhl/fedex"]').attr(
            'selected',
            false,
          );
          $('.ship-method-select option[value="cj"]').attr('selected', false);
          $('.ship-method-select option[value="skynet"]').attr('selected', false);
          $('.ship-method-select option[value="airparcel"]').hide();
          $('.ship-method-select option[value="cj"]').hide();
          $('.ship-method-select option[value="ninjavan"]').show();
          $('.ship-method-select option[value="chunghwa"]').hide();
          $('.ship-method-select option[value="sagawa"]').hide();
          $('.ship-method-select option[value="usps"]').hide();
          $('.ship-method-select option[value="skynet"]').hide();
          $('.ship-method-select option[value="dhl/fedex"]').show();
          $('.ship-method-select option[value="ninjavan"]').attr(
            'selected',
            'selected',
          );
          break;
        case 'Taiwan':
          $('.ship-method-select option[value="dhl/fedex"]').attr(
            'selected',
            false,
          );
          $('.ship-method-select option[value="cj"]').attr('selected', false);
          $('.ship-method-select option[value="skynet"]').attr('selected', false);
          $('.ship-method-select option[value="airparcel"]').hide();
          $('.ship-method-select option[value="cj"]').hide();
          $('.ship-method-select option[value="ninjavan"]').hide();
          $('.ship-method-select option[value="chunghwa"]').show();
          $('.ship-method-select option[value="sagawa"]').hide();
          $('.ship-method-select option[value="usps"]').hide();
          $('.ship-method-select option[value="skynet"]').hide();
          $('.ship-method-select option[value="dhl/fedex"]').show();
          $('.ship-method-select option[value="chunghwa"]').attr(
            'selected',
            'selected',
          );
          break;
        case 'Japan':
          $('.ship-method-select option[value="dhl/fedex"]').attr(
            'selected',
            false,
          );
          $('.ship-method-select option[value="cj"]').attr('selected', false);
          $('.ship-method-select option[value="skynet"]').attr('selected', false);
          $('.ship-method-select option[value="airparcel"]').hide();
          $('.ship-method-select option[value="cj"]').hide();
          $('.ship-method-select option[value="ninjavan"]').hide();
          $('.ship-method-select option[value="chunghwa"]').hide();
          $('.ship-method-select option[value="sagawa"]').show();
          $('.ship-method-select option[value="usps"]').hide();
          $('.ship-method-select option[value="skynet"]').hide();
          $('.ship-method-select option[value="dhl/fedex"]').show();
          $('.ship-method-select option[value="sagawa"]').attr(
            'selected',
            'selected',
          );
          break;
        case 'United States':
          $('.ship-method-select option[value="cj"]').attr('selected', false);
          $('.ship-method-select option[value="skynet"]').attr('selected', false);
          $('.ship-method-select option[value="airparcel"]').hide();
          $('.ship-method-select option[value="cj"]').hide();
          $('.ship-method-select option[value="ninjavan"]').hide();
          $('.ship-method-select option[value="chunghwa"]').hide();
          $('.ship-method-select option[value="sagawa"]').hide();
          $('.ship-method-select option[value="usps"]').show();
          $('.ship-method-select option[value="skynet"]').hide();
          $('.ship-method-select option[value="dhl/fedex"]').show();
          $('.ship-method-select option[value="dhl/fedex"]').attr(
            'selected',
            'selected',
          );
          break;
        default:
          $('.ship-method-select option[value="cj"]').attr('selected', false);
          $('.ship-method-select option[value="skynet"]').attr('selected', false);
          $('.ship-method-select option[value="airparcel"]').show();
          $('.ship-method-select option[value="cj"]').hide();
          $('.ship-method-select option[value="ninjavan"]').hide();
          $('.ship-method-select option[value="chunghwa"]').hide();
          $('.ship-method-select option[value="sagawa"]').hide();
          $('.ship-method-select option[value="usps"]').hide();
          $('.ship-method-select option[value="skynet"]').hide();
          $('.ship-method-select option[value="dhl/fedex"]').show();
          $('.ship-method-select option[value="dhl/fedex"]').attr(
            'selected',
            'selected',
          );
      }
    });
  
    function deserializeKeyValue(keyValue) {
      const [key, value] = keyValue.split('=');
      return [
        decodeURIComponent(key),
        decodeURIComponent(value.replace(/\+/g, ' ')),
      ];
    }
  
    function extractProductKey(productIndex, field) {
      return `contact[${field}${productIndex}]`;
    }
  
    function deserializeForm(serializedForm) {
      const formArray = serializedForm.split('&');
      const json = {};
  
      formArray.forEach((item) => {
        const [key, value] = deserializeKeyValue(item);
        json[key] = value;
      });
  
      const productFieldMap = {
        price: 'price',
        qty: 'quantity',
        comment: 'comments',
        bunjang: 'secondHand',
        title: 'itemName',
        link: 'itemUrl',
      };
      const productIndexRegex = /contact\[price(\d+)\]/;
      const convertedObject = {
        totalEstimateShown: json['TotalEstimateShown'],
        estimateWeight: json['contact[EstimateWeight]'],
        totalEstimate: json['contact[TotalEstimate]'],
        bunjangEstimate: json['contact[bunjangEstimate]'],
        country: json['contact[country]'],
        email: json['contact[email]'],
        name: json['contact[name]'],
        shipMethod: json['contact[shipMethod]'],
        taxAgree: json['contact[taxAgree]'],
        form_type: json['form_type'],
        utf8: json['utf8'],
        products: [],
      };
  
      for (const key in json) {
        const match = key.match(productIndexRegex);
        if (match) {
          const productIndex = match[1];
          const product = {};
          Object.keys(productFieldMap).forEach((field) => {
            const productKey = extractProductKey(productIndex, field);
            product[productFieldMap[field]] = json[productKey];
          });
  
          product.secondHand = product.secondHand ?  product.secondHand.toLowerCase() === 'yes' : false;
          
          convertedObject.products.push(product);
        }
      }
  
      return convertedObject;
    }
  
    $('#testBtn').click(function () {
      $('#testBtn').css('background-color', '#999');
      $('#submit_alert').css('background-color', '#999');
      $('#testBtn').attr('disabled', true);
      $('#submit_alert').attr('disabled', true);
      var estTotalPrice = 0;
      var bunjangFees = 0;
      var bunjangItems = 0;
      var toRemDiv = new Array();
  
      for (index = 0; index < arrProd.length; ++index) {
        var numField = arrProd[index];
        var nameField = 'contact[price' + numField + ']';
  
        var linkField = 'contact[link' + numField + ']';
        var linkVal = $('[name="' + linkField + '"]').val();
        var titleField = 'contact[title' + numField + ']';
        var titleVal = $('[name="' + titleField + '"]').val();
  
        if (linkVal === '' && titleVal === '') {
          remDiv(numField);
          toRemDiv.push(numField);
        } else {
          var wonPrice = $('[name="' + nameField + '"]').val();
          wonPrice = wonPrice.replace(/[^0-9]/, '');
          var nameField = 'contact[qty' + numField + ']';
          var qtyNow = $('[name="' + nameField + '"]').val();
  
          if (Math.floor(qtyNow) == qtyNow && $.isNumeric(qtyNow)) {
            //do nothing for now
          } else {
            $('[name="' + nameField + '"]').val('1');
            qtyNow = 1;
          }
  
          wonPrice = wonPrice * qtyNow;
          if (wonPrice < exchPrice) {
            var estPrice = 1;
          } else {
            var estPrice = Math.round((wonPrice / exchPrice) * 100) / 100;
          }
          estTotalPrice = estTotalPrice + estPrice;
  
          var bunjangField = 'ContactFormBunjang' + numField;
          if ($('#' + bunjangField).is(':checked')) {
            bunjangFees = bunjangFees + 5;
            bunjangItems = bunjangItems + 1;
            estTotalPrice = estTotalPrice + 5;
          }
        }
      }
  
      //remove empty divs
      for (index = 0; index < toRemDiv.length; ++index) {
        var delNum = toRemDiv[index];
        for (jindex = 0; jindex < arrProd.length; ++jindex) {
          if (arrProd[jindex] == delNum) {
            arrProd.splice(jindex, 1);
            jindex = arrProd.length;
          }
        }
      }
  
      var getShipMethod = $('#shipMethods').val();
      var getWeight = Math.ceil($('#estimatedWeight').val() * 2) / 2;
      var overweight = 0;
      var weightPrice = 0;
  
      if (getWeight < 1) {
        getWeight = 1;
      }
  
      var moreone = getWeight - 1;
      if (moreone > 0) {
        overweight = moreone * 10;
      }
  
      if (getShipMethod == 'airparcel' && getWeight > 2) {
        getShipMethod = 'dhl';
      }
  
      switch (getShipMethod) {
        case 'dhl':
        case 'fedex':
        case 'dhl/fedex':
          weightPrice = overweight + 34;
          break;
        case 'airparcel':
        case 'skynet':
        case 'cj':
        case 'ninjavan':
        case 'usps':
        case 'chunghwa':
        case 'sagawa':
          weightPrice = overweight + 20;
          break;
        default:
          weightPrice = overweight + 34;
      }
  
      if (estTotalPrice > 0) {
        estTotalPrice = estTotalPrice + weightPrice;
        estTotalPrice = estTotalPrice + 5;
        estTotalPrice = estTotalPrice.toFixed(2);
        $('#estimatedWeight').val(getWeight);
        $('#bunjangEstimate').val(
          'USD$' +
            bunjangFees +
            ' for ' +
            bunjangItems +
            ' product(s) (Estimation only)',
        );
        $('#totalEstimate').val('USD$' + estTotalPrice + ' (Estimation only)');
        $('#totalEstimateShown').val(
          'USD$' + estTotalPrice + ' (Estimation only)',
        );
      }
  
      $('div[name=addedDiv]').each(function (i) {
        var j = i + 1;
        var $this = $(this);
        $this.find('#ContactFormLink').attr('name', 'contact[link' + j + ']');
        $this.find('#ContactFormTitle').attr('name', 'contact[title' + j + ']');
        $this.find('#ContactFormPrice').attr('name', 'contact[price' + j + ']');
        $this.find('#ContactFormQty').attr('name', 'contact[qty' + j + ']');
        $this
          .find('#ContactFormBunjang2')
          .attr('name', 'contact[bunjang' + j + ']');
        $this
          .find('#ContactFormMessage')
          .attr('name', 'contact[comment' + j + ']');
      });
  
      let data = $('.contact-form').serialize();
      const email = $('#email').val();
      const taxvalue = $('#agree-to-pay').val()
        ? $('#agree-to-pay').val()
        : 'N/A';
      data += `&contact[email]=${email}&contact[taxAgree]=${taxvalue}`;
      const jsonObject = deserializeForm(data);
      const BASE_API = "https://supply.harum.io";
  
      $.ajax({
        type: 'POST',
        url: BASE_API + '/api/custom-orders',
        data: JSON.stringify(jsonObject),
        headers: {
          'Content-Type': 'application/json',
        },
        success: function () {
          $('#formWait').css('display', 'none');
          $('#formOK').show();
          setTimeout(location.reload.bind(location), 6000);
        },
        error: function () {
          //fornow using error as script is not returning true yet
          //alert("Thank you for your inquiry. Our team will get back to you shortly.");
          //location.reload();
        },
      });
  
      $('#prompt-background').css('display', 'none');
      $('#formWait').show();
      document.cookie = 'customProducts=; path=/;';
      document.cookie = 'customPrices=; path=/;';
      document.cookie = 'customNames=; path=/;';
    });
  
    $('#ok-popup1').click(function () {
      $('#formOK').css('display', 'none');
      location.reload();
    });
  
    $('#estBtn').click(function () {
      const name = $('#name').val();
      const emailadd = $('#email').val();
  
      if (name == '' && emailadd == '') {
        $('#validate-ne').show();
        $('#ok-ne').click(function () {
          $('#validate-ne').css('display', 'none');
        });
  
        $('#name').css('border-color', 'red');
        $('#email').css('border-color', 'red');
        $('#name').focus();
  
        //ValidateName(name);
        ValidateEmail2(emailadd);
      }
  
      if (name == '' && emailadd != '') {
        ValidateName(name);
      }
  
      if (name != '' && emailadd == '') {
        ValidateEmail(emailadd);
      }
  
      var linkok = checkLink();
      if (linkok == null) {
        linkok = true;
      }
      if (!linkok) {
        // link is empty
      } else {
        var estTotalPrice = 0;
        var bunjangFees = 0;
        var bunjangItems = 0;
        var toRemDiv = new Array();
  
        for (index = 0; index < arrProd.length; ++index) {
          var numField = arrProd[index];
          var nameField = 'contact[price' + numField + ']';
  
          var linkField = 'contact[link' + numField + ']';
          var titleField = 'contact[title' + numField + ']';
          var linkVal = $('[name="' + linkField + '"]').val();
          var titleVal = $('[name="' + titleField + '"]').val();
  
          if (linkVal === '' && titleVal === '') {
            remDiv(numField);
            toRemDiv.push(numField);
          } else {
            var wonPrice = $('[name="' + nameField + '"]').val();
            wonPrice = wonPrice.replace(/[^0-9]/, '');
  
            var nameField = 'contact[qty' + numField + ']';
            var qtyNow = $('[name="' + nameField + '"]').val();
  
            if (Math.floor(qtyNow) == qtyNow && $.isNumeric(qtyNow)) {
              //do nothing for now
            } else {
              $('[name="' + nameField + '"]').val('1');
              qtyNow = 1;
            }
  
            wonPrice = wonPrice * qtyNow;
            if (wonPrice < exchPrice) {
              var estPrice = 1;
            } else {
              var estPrice = Math.round((wonPrice / exchPrice) * 100) / 100;
            }
  
            estTotalPrice = estTotalPrice + estPrice;
  
            var bunjangField = 'ContactFormBunjang' + numField;
            if ($('#' + bunjangField).is(':checked')) {
              bunjangFees = bunjangFees + 5;
              bunjangItems = bunjangItems + 1;
              estTotalPrice = estTotalPrice + 5;
            }
          }
        }
  
        //remove empty divs
        for (index = 0; index < toRemDiv.length; ++index) {
          var delNum = toRemDiv[index];
          for (jindex = 0; jindex < arrProd.length; ++jindex) {
            if (arrProd[jindex] == delNum) {
              arrProd.splice(jindex, 1);
              jindex = arrProd.length;
            }
          }
        }
  
        //get estimated shipping
        var getShipMethod = $('#shipMethods').val();
        var getWeight = Math.ceil($('#estimatedWeight').val() * 2) / 2;
        var overweight = 0;
        var weightPrice = 0;
  
        var moreone = getWeight - 1;
  
        if (moreone > 0) {
          overweight = moreone * 10;
        }
  
        if (getShipMethod == 'airparcel' && getWeight > 2) {
          getShipMethod = 'dhl';
        }
  
        switch (getShipMethod) {
          case 'dhl':
          case 'fedex':
          case 'dhl/fedex':
            weightPrice = overweight + 34;
            break;
          case 'airparcel':
          case 'skynet':
          case 'cj':
          case 'ninjavan':
          case 'usps':
          case 'chunghwa':
          case 'sagawa':
            weightPrice = overweight + 20;
            break;
          default:
            weightPrice = overweight + 34;
        }
  
        if (estTotalPrice > 0) {
          estTotalPrice = estTotalPrice + weightPrice;
          estTotalPrice = estTotalPrice + 5;
          estTotalPrice = estTotalPrice.toFixed(2);
          $('#bunjangEstimate').val(
            'USD$' +
              bunjangFees +
              ' for ' +
              bunjangItems +
              ' product(s) (Estimation only)',
          );
          $('#totalEstimate').val('USD$' + estTotalPrice + ' (Estimation only)');
          $('#totalEstimateShown').val(
            'USD$' + estTotalPrice + ' (Estimation only)',
          );
        }
      }
    });
  
    $('#btn1').click(function () {
      if (listedNumber >= 1) {
      } else {
        productNumber = 2;
        listedNumber = 2;
        arrProd.push(1);
      }
  
      arrProd.push(productNumber);
  
      var imageForm =
        '<div><img id = "image' +
        productNumber +
        '" style="width: 200px;"></div>';
      var linkForm =
        '<div class="form-group required"><label class="col-sm-2 control-label" for="ContactFormLink">Item URL</label><div class="col-sm-10"><input required="required" type="text" id="ContactFormLink" class="form-control" name="contact[link' +
        productNumber +
        ']" placeholder="Paste URL here"></div></div>';
      var titleForm =
        '<div class="form-group required"><label class="col-sm-2 control-label" for="ContactFormTitle">Item Name</label><div class="col-sm-10"><input required="required" type="text" id="ContactFormTitle" class="form-control" name="contact[title' +
        productNumber +
        ']" placeholder="Paste Item Name here"></div></div>';
  
      var bunjangForm =
        '<div class="form-group"><label class="col-sm-2 control-label" for="ContactFormBunjang' + 
        productNumber +
        '">2nd hand item?</label><div class="col-sm-10"><input type="checkbox" id="ContactFormBunjang' +
        productNumber +
        '" name="contact[bunjang' +
        productNumber +
        ']" value="yes" /> Eg. Bunjang / Naver/ Daum Cafe / Etc.</div></div>';
  
      var priceForm =
        '<div class="form-group"><label for="ContactFormPrice" class="col-sm-2 control-label">Price</label><div class="col-sm-10"><input required="required" type="number" step="any" id="ContactFormPrice" class="form-control" name="contact[price' +
        productNumber +
        ']" placeholder="Price in Won" oninput="this.setCustomValidity(' +
        "''" +
        ')" oninvalid="this.setCustomValidity(' +
        "'Please put number only in Price'" +
        ')"></div></div>';
      var qtyForm =
        '<div class="form-group"><label for="ContactFormQty" class="col-sm-2 control-label">Quantity</label><div class="col-sm-10"><input required="required" type="number" id="ContactFormQty" class="form-control" name="contact[qty' +
        productNumber +
        ']" placeholder="How many would you like to buy?"></div></div>';
      var commentForm =
        '<div class="form-group"><label for="ContactFormMessage" class="col-sm-2 control-label">Comments</label><div class="col-sm-10"><textarea rows="3" id="ContactFormMessage" class="form-control" name="contact[comment' +
        productNumber +
        ']" placeholder="Size / Color / Etc"></textarea></div></div>';
  
      var temp =
        '<div id = "plusitem' +
        productNumber +
        '" name="addedDiv"><h3 name="divTitle' +
        productNumber +
        '">Product ' +
        listedNumber +
        '<button name="delete" data-id="plusitem' +
        productNumber +
        '" ' +
        'class="btn pull-right" style="float: right;" value="' +
        '" style="float: right;">Remove Item</button></h3>' +
        imageForm +
        linkForm +
        titleForm +
        bunjangForm +
        priceForm +
        qtyForm +
        commentForm;
  
      htmlStr = temp; // +temp2;
  
      $('#itemList').append($(htmlStr));
      productNumber++;
      listedNumber++;
    });
  
    $('#itemList').on('click', 'button[name=delete]', function (e) {
      e.preventDefault();
      var $this = $(this);
      var targetDiv = $this.attr('data-id');
      var delNum = targetDiv.substring(8);
      for (index = 0; index < arrProd.length; ++index) {
        if (arrProd[index] == delNum) {
          var delLink = $('#' + targetDiv).attr('customSearch');
          if (delLink) {
            var timeToAdd = 1000 * 60 * 60 * 24 * 2;
            var date = new Date();
            var expiryTime = parseInt(date.getTime()) + timeToAdd;
            date.setTime(expiryTime);
            var utcTime = date.toUTCString();
  
            customProductArray.splice(index, 1);
            customPriceArray.splice(index, 1);
            customNameArray.splice(index, 1);
  
            document.cookie =
              'customProducts=' +
              customProductArray.toString() +
              '; expires=' +
              utcTime +
              '; path=/;';
            document.cookie =
              'customPrices=' +
              customPriceArray.toString() +
              '; expires=' +
              utcTime +
              '; path=/;';
            document.cookie =
              'customNames=' +
              customNameArray.toString() +
              '; expires=' +
              utcTime +
              '; path=/;';
  
            console.log(document.cookie);
          }
  
          arrProd.splice(index, 1);
        }
      }
  
      if (listedNumber <= 2) {
        $("input[name='contact[link1]']").val('');
        $("input[name='contact[price1]']").val('');
        $("input[name='contact[title1]']").val('');
        $("input[name='contact[comment1]']").val('');
        $("input[name='contact[qty1]']").val('');
        $("input[name='contact[bunjang1]]']").prop('checked', false);
        $('#image1').attr('src', '');
      } else {
        $('#' + targetDiv).remove();
      }
  
      $('div[name=addedDiv]').each(function (i) {
        // div 중에 name이 addedDiv인 애들을 모두 가져와서 for문을 돌아
        // 파라미터 i는 index
        var $this = $(this);
        var curNum = $this.attr('id').substring(8);
  
        if (i + 1 != curNum) {
          $this.attr('id', 'plusitem' + (i + 1));
          $this.attr('customSearch', i);
          // $('h3[name=divTitle' + curNum + ']').html("Product " + (i + 1) + '<button name="delete" data-id="plusitem' + (i + 1) + '" ' +
          //                                           'class="btn pull-right" style="float: right;" value="' + deleteBtn + '">Remove Item</button>').attr("name", "divTitle" + (i + 1));
          $('h3[name=divTitle' + curNum + ']')
            .html(
              'Product ' +
                (i + 1) +
                '<button name="delete" data-id="plusitem' +
                (i + 1) +
                '" ' +
                'class="btn pull-right" style="float: right;" value="' +
                '">Remove Item</button>',
            )
            .attr('name', 'divTitle' + (i + 1));
        }
      });
  
      //productNumber--;
      listedNumber--;
    });
  
    if (customProducts != null) {
      for (var i = 0; i < customProductArray.length - 1; i++) {
        document.querySelector('#btn1').click();
      }
  
      var j = 0;
      for (var i = 1; i <= customProductArray.length; i++) {
        if (customProductArray[j]) {
          $("input[name='contact[link" + i + "]']").val(
            customProductArray[j],
          );
          $("input[name='contact[price" + i + "]']").val(customPriceArray[j]);
          $("input[name='contact[title" + i + "]']").val(
            decodeURIComponent(customNameArray[j]),
          );
          $('#plusitem' + i).attr('customSearch', j);
          $('#image' + i).attr('src', customImageArray[j]);
          j++;
        }
      }
    }
});